import {Component, Input} from '@angular/core';
import {ExcTranslation} from 'exc-core';
import {DefaultSettingsService} from '../../default-settings-service.service';

@Component({
  selector: 'inventory-waffle',
  templateUrl: './inventory-waffle.component.html',
  styles: []
})
export class InventoryWaffleComponent extends ExcTranslation {

  @Input() inventory;
  constructor(private excDss: DefaultSettingsService) {
   super();
  }
}
